import { RefObject, useEffect, useRef, useState } from 'react';
import getIsClampEnabled from '~/utilities/getIsClampEnabled';

export default function useIsClampEnabled(
  ref: RefObject<HTMLElement | null>,
  isExpanded = false
) {
  const [isClampEnabled, setIsClampEnabled] = useState(false);
  const isExpandedRef = useRef(isExpanded);

  useEffect(() => {
    isExpandedRef.current = isExpanded;

    if (!isExpanded) setIsClampEnabled(getIsClampEnabled(ref.current));
  }, [isExpanded, ref]);

  useEffect(() => {
    const el = ref.current;

    if (!el) return;

    let previousWidth: number;

    const resizeObserver = new ResizeObserver(() => {
      if (el.clientWidth === previousWidth) return;

      previousWidth = el.clientWidth;

      if (isExpandedRef.current) return;

      setIsClampEnabled(getIsClampEnabled(el));
    });

    resizeObserver.observe(el);

    setIsClampEnabled(getIsClampEnabled(el));

    return () => {
      resizeObserver.disconnect();
    };
  }, [ref]);

  return isClampEnabled;
}
